import { Text, VStack } from "@chakra-ui/react";

import {
  ConfirmationDialog,
  ConfirmationDialogProps,
} from "@/common/components/ConfirmationDialog";
import FormInput from "@/common/components/Form/FormInput";
import { FormRootError } from "@/common/components/Form/FormRootError";
import { ManagedFormControl } from "@/common/components/Form/ManagedFormControl";
import { FeatureTargetingProposedChanges } from "@/feature/components/FeatureTargetingProposedChanges";
import { TargetingNotificationDefaultsInfo } from "@/feature/utils/targetingNotificationDefaults";
import { FeatureDetail } from "@reflag/shared/featureAPI";
import { UpdateEnvironmentFeatureTargeting } from "@reflag/shared/featureTargetingAPI";
import { StageDTO } from "@reflag/shared/stageAPI";

import { FeatureTargetingUpdateNotificationCallout } from "./FeatureTargetingUpdateNotificationCallout";

type FeatureTargetingChangeConfirmationDialogProps = Omit<
  ConfirmationDialogProps,
  "description" | "title"
> & {
  feature: FeatureDetail;
  stages: StageDTO[];
  newStageId: string | null;
  currentTargeting: UpdateEnvironmentFeatureTargeting[];
  targetingSnapshot: UpdateEnvironmentFeatureTargeting[];
  newTargeting: UpdateEnvironmentFeatureTargeting[];
  canChangeStage: boolean;
  onStageChange?: (stageId: string) => void;
  notificationDefaultsInfo?: TargetingNotificationDefaultsInfo;
};

export const FeatureTargetingChangeConfirmationDialog = ({
  feature,
  stages,
  newStageId,
  currentTargeting,
  targetingSnapshot,
  newTargeting,
  canChangeStage,
  onStageChange,
  notificationDefaultsInfo,
  ...rest
}: FeatureTargetingChangeConfirmationDialogProps) => {
  return (
    <ConfirmationDialog
      {...rest}
      _bodyProps={{
        px: 0,
      }}
      _contentProps={{
        maxW: "3xl",
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      description={
        <VStack spacing={4} w="full">
          <FeatureTargetingProposedChanges
            canChangeStage={canChangeStage}
            currentTargeting={currentTargeting}
            feature={feature}
            newStageId={newStageId}
            newTargeting={newTargeting}
            onStageChange={onStageChange}
            stages={stages}
            targetingSnapshot={targetingSnapshot}
          />
          <VStack px={8} spacing={4} w="full">
            <FormInput
              name="changeDescription"
              placeholder="Add a reason for the changes..."
            />
            <FormRootError />
            <ManagedFormControl
              name="notifications"
              render={({ field }) => (
                <FeatureTargetingUpdateNotificationCallout
                  defaultInfo={notificationDefaultsInfo}
                  feature={feature}
                  {...field}
                />
              )}
            />
          </VStack>
        </VStack>
      }
      title={<Text whiteSpace="nowrap">Confirm rules update</Text>}
    />
  );
};
